import { UserIcon } from '@repo/icons';
import { type TestId } from '@repo/test-id';
import { tr } from '@repo/locale';
import { Button } from '@repo/ui';

import { MapPinPreviewIcon } from '@features/ownedParkingLocation';

import authBannerBackground from '@assets/images/account/auth-banner-background.webp';

interface Props {
  onLogin: () => void;
  onRegister: () => void;
  testId: TestId;
}

export default function AuthBanner({ onLogin, onRegister, testId }: Props) {
  return (
    <div
      className="bg-brand-2 relative isolate mt-auto flex w-full flex-col items-center rounded-t-2xl px-4 pt-12 pb-6"
      data-testid={testId}
    >
      <div className="relative z-2 flex w-full flex-col items-center gap-6 text-center">
        <div className="flex flex-col gap-2">
          <h2 className="text-heading font-sans text-base leading-6 font-semibold">{tr('account:banner.title')}</h2>
          <p className="text-heading text-sm text-balance">{tr('account:banner.subtitle')}</p>
        </div>

        <div className="flex w-full justify-center gap-3">
          <Button
            testId={testId.append('loginButton')}
            label={tr('account:banner.login_button')}
            leftIcon={UserIcon}
            color="secondary"
            className="w-fit bg-white"
            onClick={onLogin}
          />
          <Button
            testId={testId.append('registerButton')}
            label={tr('account:banner.register_button')}
            leftIcon={UserIcon}
            color="brand"
            className="w-fit"
            onClick={onRegister}
          />
        </div>
      </div>

      <div className="z-base absolute inset-0 overflow-hidden" aria-hidden>
        <div className="bg-account-banner-radial z-base absolute top-1/2 left-1/2 h-80 w-80 -translate-x-1/2 -translate-y-1/2" />
      </div>

      <img src={authBannerBackground} className="absolute bottom-0 h-40 w-full" alt="" aria-hidden />

      <div className="absolute top-0 left-1/2 z-2 -translate-x-1/2 -translate-y-1/2">
        <MapPinPreviewIcon className="text-brand-2 h-12 w-12 drop-shadow-lg" />
      </div>
    </div>
  );
}
